module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('claim-blank-form', {
    attrs: {
      "submit-label": "Добавить заявку",
      "claim": _vm.claim,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processClaimForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eeeb43e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/claim/ClaimAddForm.vue
// module id = 640
// module chunks = 0